import { useEffect } from "react";
import { useNavigate } from "react-router";
import type { FormState } from "./formState";

// The counterpart to the `redirect()` the server actions used to end on. A
// form that saved successfully sets status "done"; this moves the router once,
// on the transition into that state.
export const useFormRedirect = (state: FormState, onDone?: () => void) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (state.status !== "done") {
      return;
    }

    onDone?.();

    if (state.redirectTo) {
      navigate(state.redirectTo);
    }
    // `onDone` is a fresh closure on every render at most call sites, and
    // depending on it would re-navigate on each one.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.status, state.redirectTo, navigate]);
};
